import { useEffect, useState } from 'react';

import { computeElapsedSeconds } from '../utils';

// Renders `now - started_at` against the server clock. Nothing is written to local storage, so
// a refresh, a second tab and a re-login all restore an identical elapsed time.
export const useElapsedTimer = (startedAt: string | null): number => {
    const [elapsedSeconds, setElapsedSeconds] = useState(() =>
        startedAt ? computeElapsedSeconds(startedAt, Date.now()) : 0
    );

    useEffect(() => {
        if (startedAt === null) {
            setElapsedSeconds(0);
            return;
        }

        // Recompute immediately so the display does not sit a tick behind the session
        setElapsedSeconds(computeElapsedSeconds(startedAt, Date.now()));

        const intervalId = window.setInterval(() => {
            setElapsedSeconds(computeElapsedSeconds(startedAt, Date.now()));
        }, 1000);

        return () => {
            window.clearInterval(intervalId);
        };
    }, [startedAt]);

    return elapsedSeconds;
};

export default useElapsedTimer;
